/**
 * Created by sjt8736 on 2017/3/8.
 */
const AesCrypto = require('./aesCrypto');
const key = 'OPABL';
let aesCrypto = new AesCrypto(key);

/*let str = aesCrypto.encrypt(JSON.stringify({
    deviceId:'1',
    token:'123123123123'
}));
console.info(str);
console.info(aesCrypto.decrypt(str));*/
module.exports = aesCrypto;